export const REDUCER_NAME = 'employee'




// WEBPACK FOOTER //
// ./src/modules/employee/state/const.js